import { SET_BALANCE, SET_EXPOSURE, SET_GAME, SET_MATCH } from "./types";

export const setExposure = (exposure) => (dispatch) =>
  dispatch({ type: SET_EXPOSURE, payload: exposure });

export const setBalance = (balance) => (dispatch) =>
  dispatch({ type: SET_BALANCE, payload: balance });

export const setMatch = (matchId, match) => (dispatch) =>
  dispatch({ type: SET_MATCH, payload: { matchId, match } });

export const setGame = (type, games) => (dispatch) =>
  dispatch({ type: SET_GAME, payload: { type, games } });



// WEBPACK FOOTER //
// ./src/redux/acctions.js